import React, { Component } from 'react';
import { connect } from 'react-redux';
import Topbar from '../containers/Topbar/Topbar';
import Footer from '../components/Footer/Footer';

import '../style/Global.scss';
import '../style/Common.scss';

class Layout extends Component {

    render() {
        return (
          <div>
            <div>
              <Topbar />
              <div className="main-top-space">
                {this.props.children}
              </div>
              <Footer />
            </div>
          </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loading: state.loading,
    };
};

Layout.defaultProps = {
    children: <div />,
};

Layout.propTypes = {
    children: React.PropTypes.element,
};

export default connect(mapStateToProps)(Layout);



// WEBPACK FOOTER //
// ./src/containers/Layout.js